// src/utils/analytics.js
export const trackEvent = (eventName, params) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag('event', eventName, params);
  } else {
    console.warn("GA4 is not initialized");
  }
};
